/**
 * @generated SignedSource<<e1192085c48690de29428a79c9d6d1b6>>
 * @relayHash e7bd81102c1dee96dbca11245e366952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696

import type { ConcreteRequest, Query } from 'relay-runtime';
export type srcAsyncEditIssueTypeQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type srcAsyncEditIssueTypeQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly issueTypes: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly avatar: {
              readonly medium: string | null | undefined;
            } | null | undefined;
            readonly description: string;
            readonly issueTypeId: string;
            readonly name: string;
          };
        } | null | undefined>;
      };
    };
  };
};
export type srcAsyncEditIssueTypeQuery = {
  response: srcAsyncEditIssueTypeQuery$data;
  variables: srcAsyncEditIssueTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "medium"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcAsyncEditIssueTypeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraIssueTypeConnection",
                      "kind": "LinkedField",
                      "name": "issueTypes",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v2/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.issueTypes.edges.node.issueTypeId"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v3/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.issueTypes.edges.node.name"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v4/*: any*/),
                                      "action": "THROW",
                                      "path": "jira.jiraProjectByKey.issueTypes.edges.node.description"
                                    },
                                    (v5/*: any*/)
                                  ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey.issueTypes.edges.node"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.jiraProjectByKey.issueTypes.edges"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.jiraProjectByKey.issueTypes"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcAsyncEditIssueTypeQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696",
    "metadata": {},
    "name": "srcAsyncEditIssueTypeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "95da41f0960685e3830143828659ecad";

export default node;
